export const BUSINESS_PARTNER = 'businessPartnerId';
export const AFFILIATES = 'affiliateIds'; //TODO: rename to AFFILIATES
export const PERIOD = 'period';
export const APPLICATIONS = 'applicationIds';
export const EXPENSE_TYPE = 'expenseType';
export const IMPORTANCE_TYPE = 'importanceType';
export const DESCRIPTION = 'description';
export const INVOICES = 'invoices';
export const ATTACHMENTS = 'attachments';

export const SPEND = 'spend';
export const SPEND_ADJUSTMENTS = 'spendAdjustments';
export const SPEND_ADJUSTMENT_REASON_ID = 8;

export const INVOICE_CURRENCY_CODE = 'currencyCode';
export const INVOICE_AMOUNT = 'amount';
export const INVOICE_TYPE = 'type';
export const INVOICE_ATTACHMENT_ID = 'attachmentId';

export const DEPENDENCIES = {
  [AFFILIATES]: [BUSINESS_PARTNER],
  [APPLICATIONS]: [BUSINESS_PARTNER, AFFILIATES, PERIOD],
  [EXPENSE_TYPE]: [BUSINESS_PARTNER, AFFILIATES],
  [SPEND]: [BUSINESS_PARTNER, AFFILIATES, PERIOD, APPLICATIONS],
  [INVOICES]: [
    BUSINESS_PARTNER,
    AFFILIATES,
    EXPENSE_TYPE,
    PERIOD,
    APPLICATIONS,
    INVOICES,
    SPEND_ADJUSTMENTS,
  ],
  [PERIOD]: [BUSINESS_PARTNER, AFFILIATES, EXPENSE_TYPE],
};
export const CREATION_GRADE_SAVE = 0;
export const CREATION_GRADE_LOWER_DIALOG = 1;
export const CREATION_GRADE_HIGHER_DIALOG = 2;
